import React from 'react'
import FilterItem from './FilterItem'

const ComponentFilterItem = ({
  filterName,
  Component,
  ...passThroughProps
}) => (
  <FilterItem filterName={filterName} key={filterName}>
    <Component {...passThroughProps} />
  </FilterItem>
)

export default ComponentFilterItem
